import { Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';

@Pipe({
  name: 'dynamicCurrency',
  standalone: false
})

export class DynamicCurrencyPipe implements PipeTransform { 
  braintreeCurrencyConversion: number = 1;
  taxLabel: string = '';
  taxRate: number = 1;

  transform(value: number, currencyCode: string, locale?: string): string {
    const symbol = getCurrencySymbol(currencyCode, 'narrow', locale);

    const formatNumber = (num: number): string => {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    };

    switch (currencyCode) {
      case 'CAD':
        this.braintreeCurrencyConversion = 1.38;
        return `${symbol}${formatNumber(value * this.braintreeCurrencyConversion)}`;

      case 'GBP':
        this.braintreeCurrencyConversion = 0.83;
        this.taxLabel = 'w/ VAT';
        this.taxRate = 1.2; //later: dynamically update rate from checkout page based on country/city/zip
        return `${symbol}${formatNumber(value * this.braintreeCurrencyConversion * this.taxRate)}`;

      case 'AUD':
        this.braintreeCurrencyConversion = 1.52;
        this.taxLabel = 'w/ GST';
        this.taxRate = 1.1; //later: dynamically update rate from checkout page based on country/city/zip
        return `${symbol}${formatNumber(value * this.braintreeCurrencyConversion * this.taxRate)}`;

      default:
        return `${symbol}${formatNumber(value * this.braintreeCurrencyConversion)}`;
    }
  }
  
  checkPriceWithTax(currencyCode: string): boolean {
    return ['AUD', 'GBP'].includes(currencyCode);
  }
}